import './Filters.scss'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import moment from 'moment'
import {Collapse, DatePicker, Input, Select, Switch, Tooltip} from 'antd'
import ImageResources from "../../../../layouts/commonComponent/components/ExternalResources/ImageResources";

const { Panel } = Collapse;

const Filters = ({currentUser, parametersClient, filters, groups, categories, areas, onChangeFilters, origin}) => {
    const {t} = useTranslation()
    const [availableComplianceBases, setAvailableComplianceBases] = useState({'PEPSAN': [], 'KYCAME': [], 'UBOCOM': [], 'ONB': []})
    const {Option} = Select

    useEffect(() => {
        init()

        const compBases = {'PEPSAN': [], 'KYCAME': [], 'UBOCOM': [], 'ONB': []}

        // PEPSAN
        if(currentUser.cliente.modules.includes('PEP')) {
          compBases['PEPSAN'].push('PEPV', 'RCAPV', 'ASOCV')
          if(currentUser.cliente.pais === 'CHI') {
            compBases['PEPSAN'].push('FP')
          }
        }
        if(currentUser.cliente.modules.includes('PFA')) {
          compBases['PEPSAN'].push('WL')
        }
        if(currentUser.cliente.modules.includes('NEG')) {
          compBases['PEPSAN'].push('NEG')
        }

        // KYCAME
        if(currentUser.cliente.modules.includes('PEPH')) {
          compBases['KYCAME'].push('PEPH', 'RCAPH', 'ASOCH')
        }
        if(currentUser.cliente.modules.includes('PERSON')) {
          compBases['KYCAME'].push('BPI')
        }
        if(currentUser.cliente.modules.includes('PEPC')) {
          compBases['KYCAME'].push('PEPC', 'RCAC')
        }
        if(currentUser.cliente.modules.includes('PFA')) {
          compBases['KYCAME'].push('AME')
        }
        if(currentUser.cliente.modules.includes('VIP')) {
          compBases['KYCAME'].push('VIP')
        }
        if(currentUser.cliente.modules.includes('PJUD-PENAL')) {
          compBases['KYCAME'].push('PJUD-P')
        }
        if(currentUser.cliente.modules.includes('PJUD-CIVIL')) {
          compBases['KYCAME'].push('PJUD-C')
        }
        if(currentUser.cliente.modules.includes('PJUD-COB')) {
          compBases['KYCAME'].push('PJUD-COB')
        }
        if(currentUser.cliente.modules.includes('PJUD-LAB')) {
          compBases['KYCAME'].push('PJUD-LAB')
        }
        if(currentUser.cliente.modules.includes('PJUD-APE')) {
          compBases['KYCAME'].push('PJUD-APE')
        }
        if(currentUser.cliente.modules.includes('PJUD-SUP')) {
          compBases['KYCAME'].push('PJUD-SUP')
        }
        if(currentUser.cliente.modules.includes('MAM')) {
          compBases['KYCAME'].push('MAM')
        }

        // UBOCOM
        if(currentUser.cliente.modules.includes('PFA')) {
          compBases['UBOCOM'].push('SOC','BRD')
        }

        // ONB
        if(currentUser.cliente.modules.includes('ONBOARDING')) {
          compBases['ONB'].push('ONB-NAT', 'ONB-EXP', 'ONB-CONS', 'ONB-MAT', 'ONB-OCTO', 'ONB-ACTE',
            'ONB-TSA', 'ONB-TSM', 'ONB-TSB', 'ONB-DONA', 'ONB-REPR', 'ONB-CI',
            'ONB-PROVI', 'ONB-PEP', 'ONB-FP')
        }

        setAvailableComplianceBases(compBases)
    }, [])

    const init = () => {
        window.setTimeout(() => {
            const sidebarEl = document.getElementById('register-sidebar')
            const contentEl = document.getElementById('register-content')
            if (sidebarEl && contentEl) {
                let contentHeight = contentEl.offsetHeight
                if(contentHeight > 1385) contentHeight = 1385;
                sidebarEl.style.height = contentHeight + 'px'
            }

        }, 2000)
    }

  const getTitleFilter = (title, options) => {
    return <div className={"filter-title"+(options && options.length > 0 ? " filter-title-activated" : "")}>
      {title}
    </div>
  }

  const getComplianceFilter = () => filters['complianceFilter'] || {}

  const getComplianceTitleOptions = () => {
    const complianceFilter = getComplianceFilter()
    return Object.keys(complianceFilter).reduce((acc, group) => {
      acc.push(group)
      const bases = complianceFilter[group]
      if (Array.isArray(bases) && bases.length > 0) {
        acc.push(...bases)
      }
      return acc
    }, [])
  }

  const isComplianceActive = (group) => Object.prototype.hasOwnProperty.call(getComplianceFilter(), group)

  const isComplianceBaseActive = (group, baseCode) => {
    const bases = getComplianceFilter()[group]
    return Array.isArray(bases) && bases.includes(baseCode)
  }

  const updateComplianceFilter = (nextFilter) => {
    const hasGroups = nextFilter && Object.keys(nextFilter).length > 0
    onChangeFilters('complianceFilter', hasGroups ? nextFilter : null, hasGroups)
  }

  const handleComplianceChange = (group, value) => {
    const nextFilter = { ...getComplianceFilter() }
    if (value) {
      nextFilter[group] = Array.isArray(nextFilter[group]) ? nextFilter[group] : []
    } else {
      delete nextFilter[group]
    }
    updateComplianceFilter(nextFilter)
  }

  const handleComplianceBaseChange = (group, baseCode, value) => {
    const nextFilter = { ...getComplianceFilter() }
    const currentBases = Array.isArray(nextFilter[group]) ? [...nextFilter[group]] : []

    if (value) {
      if (!currentBases.includes(baseCode)) {
        currentBases.push(baseCode)
      }
      nextFilter[group] = currentBases
    } else {
      nextFilter[group] = currentBases.filter(code => code !== baseCode)
    }

    updateComplianceFilter(nextFilter)
  }

  const renderComplianceBases = (group) => {
    if (!isComplianceActive(group)) return null

    let bases = availableComplianceBases[group] || []
    if (group === 'ONB' && currentUser.cliente.pais !== 'PER') {
      bases = bases.filter(code => code !== 'ONB-PROVI')
    }

    return (
      <ul className="compliance-bases">
        {bases.map(baseCode => {
          const label = t('messages.aml.compliance.base.' + baseCode)
          return (
            <li key={baseCode} className="compliance-filter-row">
              <Tooltip title={label} placement="topLeft">
                <span className="compliance-filter-label">{label}</span>
              </Tooltip>
              <Switch
                size="small"
                checked={isComplianceBaseActive(group, baseCode)}
                onChange={(value) => handleComplianceBaseChange(group, baseCode, value)}
              />
            </li>
          )
        })}
      </ul>
    )
  }

    const getUrlPerson =(id) => {
        return  ('/getImageClientUser/0/' + id)
    }

  return (
    <div id="filters" className="filters-register">

        <Collapse expandIconPosition="right" bordered={false} defaultActiveKey={["filter-1", "filter-2", "filter-3", "filter-4", "filter-5", "filter-6", "filter-7", "filter-8", "filter-9", "filter-10", "filter-11", "filter-17"]}>
          { currentUser.cliente.outsourcer && currentUser.cliente.clientes !== null && currentUser.cliente.clientes.length > 0 && currentUser.subcliente === null &&
          <Panel header={ t('messages.aml.subclient') } key="filter-1">
            <div className="filter">
              <Select onChange={ (value) => onChangeFilters('subclienteId', value, value) }
                placeholder="Seleccionar empresa"
                className="subclient-dropdown"
                allowClear
                >
                { currentUser.cliente.clientes.map(item =>
                    <Option className="subclient-option" value={ item.id }>
                      <div className="subclient-option-inner">
                        <figure className="subclient-logo">
                            <ImageResources url={getUrlPerson(item.id)} styleResource={{ height: '15px' }} ></ImageResources>
                        </figure>
                        <span className="subclient-name" style={{ paddingLeft: '10px' }}>{ item.name }</span>
                      </div>
                    </Option>
                  )
                }
              </Select>
            </div>
          </Panel>
        }
        { currentUser.cliente.modules.includes('MONITOR-AML') && (origin === 'new' || (filters['filterFalsosPositivos'] && filters['filterFalsosPositivos'] > 0)) &&
          <Panel header={t("messages.aml.register.filter.nameMatches")} key="filter-2">
            <div className="filter">
              <ul>
                { origin === 'new' &&
                  <li>{t("messages.aml.register.filter.hasMatches")} <Switch size="small" checked={ filters['falsosPositivos'] } onChange={ (value) => onChangeFilters('falsosPositivos', value, value) } /></li>
                }
                { filters['filterFalsosPositivos'] > 0 &&
                  <li className="falsos-positivos">{ t('messages.aml.posibleFalsosPositivos') } ({ filters['filterFalsosPositivos'] }) <Switch size="small" checked={ filters['falsosPositivosPendientes'] } onChange={ (value) => onChangeFilters('falsosPositivosPendientes', value, value) } /></li>
                }
              </ul>
            </div>
          </Panel>
        }
        { filters['filterFecAlerta'] && filters['filterFecAlerta'] !== '' &&
          <Panel header={ t('messages.aml.alertDate') } key="filter-3">
            <div className="filter">
              <ul>
                <li>{ moment(moment(filters['filterFecAlerta'],'YYYY-MM-DD')).format('DD MMMM YYYY') } <Switch size="small" checked={ filters['fecAlerta'] !== null || filters['fecAlerta'] === undefined } onChange={ (value) => onChangeFilters('fecAlerta', filters['filterFecAlerta'], value) } /></li>
              </ul>
            </div>
          </Panel>
        }
        { origin !== "new" &&
          <Panel header={ t('messages.aml.keywordSearch') } key="filter-4">
            <div className="filter">
              <Input.Search placeholder={ t('messages.aml.searhcDniNameEmail') } onSearch={ (value) => onChangeFilters('text', value, value!=='') } allowClear />
            </div>
          </Panel>
        }
        <Panel header={ getTitleFilter(t('messages.aml.type'), filters['types'])} key="filter-5">
          <div className="filter">
            <ul>
              <li>{ t('messages.aml.naturalPerson') } <Switch size="small" checked={ filters['types'] && filters['types'].includes('Person') } onChange={ (value) => onChangeFilters('types', 'Person', value) } /></li>
              <li>{ t('messages.aml.legalPerson') } <Switch size="small" checked={ filters['types'] && filters['types'].includes('Entity') } onChange={ (value) => onChangeFilters('types', 'Entity', value) } /></li>
            </ul>
          </div>
        </Panel>
        <Panel header={getTitleFilter(t('messages.aml.pjStatus'), filters['estados'])} key="filter-9">
          <div className="filter">
            <ul>
              <li>{ t('messages.aml.active') } <Switch size="small" checked={ filters['estados'] && filters['estados'].includes('ACTIVE') } onChange={ (value) => onChangeFilters('estados', 'ACTIVE', value) } /></li>
              <li>{ t('messages.aml.inactive') } <Switch size="small" checked={ filters['estados'] && filters['estados'].includes('INACTIVE') } onChange={ (value) => onChangeFilters('estados', 'INACTIVE', value) }/></li>
            </ul>
          </div>
        </Panel>
        { categories && categories.length > 0 && (categories.length > 1 || categories[0].categoria !== 'N/A') &&
          <Panel header={ getTitleFilter(t('messages.aml.category'), filters['categories']) } key="filter-6">
            <div className="filter">
              <ul>
                { categories.map(category =>
                  <li>
                  { category.categoria !== 'N/A' ? t('messages.aml.category.' + category.categoria) : 'N/A' } ({ category.cant }) <Switch size="small" checked={ filters['categories'] && filters['categories'].includes(category.categoria) } onChange={ (value) => onChangeFilters('categories', category.categoria, value) } />
                  </li>
                )}
              </ul>
            </div>
          </Panel>
        }
        { areas && areas.length > 0 && (areas.length > 1 || areas[0].area !== 'N/A') &&
          <Panel header={getTitleFilter(t('messages.aml.area'), filters['areas'])} key="filter-7">
            <div className="filter">
              <ul>
                { areas.map(area =>
                  <li>
                  { area.area } ({ area.cant }) <Switch size="small" checked={ filters['areas'] && filters['areas'].includes(area.area) } onChange={ (value) => onChangeFilters('areas', area.area, value) } />
                  </li>
                )}
              </ul>
            </div>
          </Panel>
        }
        { groups && groups.length > 0 && (groups.length > 1 || groups[0].grupo !== 'N/A') &&
          <Panel header={getTitleFilter(t('messages.aml.group'), filters['grupos'])} key="filter-8">
            <div className="filter">
              <ul>
                { groups.map(group =>
                  <li>
                  { group.grupo } ({ group.cant }) <Switch size="small" checked={ filters['grupos'] && filters['grupos'].includes(group.grupo) } onChange={ (value) => onChangeFilters('grupos', group.grupo, value) } />
                  </li>
                )}
              </ul>
            </div>
          </Panel>
        }

        <Panel header={t('messages.aml.uploadDate')} key="filter-10">
          <div className="filter">
            <DatePicker format="DD/MM/YYYY" placeholder={ t('messages.aml.from') } style={{ marginBottom: '5px', width: '100%' }} onChange={ (value) => onChangeFilters('fromDate', value === null ? null : moment(value).format('DD/MM/YYYY'), value !== '') } />
            <DatePicker format="DD/MM/YYYY" placeholder={ t('messages.aml.to') } style={{ width: '100%' }} onChange={ (value) => onChangeFilters('toDate', value === null ? null : moment(value).format('DD/MM/YYYY'), value !== '') } />
          </div>
        </Panel>
        { currentUser.cliente.modules.includes('ADMCLI') && parametersClient && parametersClient.ubofinder && parametersClient.ubofinder.noInvestigaMalla === false &&
            <Panel header={getTitleFilter(t('messages.aml.malla.status'), filters['estadoMalla'])} key="filter-11">
              <div className="filter">
                <ul>
                  <li>{ t('messages.aml.malla.SOLICITADO') } <Switch size="small" checked={ filters['estadoMalla'] && filters['estadoMalla'].includes('SOLICITADO') } onChange={ (value) => onChangeFilters('estadoMalla', 'SOLICITADO', value) } /></li>
                  <li>{ t('messages.aml.malla.ENTREGADO') } <Switch size="small" checked={ filters['estadoMalla'] && filters['estadoMalla'].includes('ENTREGADO') } onChange={ (value) => onChangeFilters('estadoMalla', 'ENTREGADO', value) } /></li>
                </ul>
              </div>
            </Panel>
        }
        { currentUser.cliente.modules.includes('ADMCLI') && parametersClient && parametersClient.ubofinder && !parametersClient.ubofinder.sinFormulario && parametersClient.ubofinder.formularioInterno &&
          <Panel header={getTitleFilter(t('messages.aml.ubofinder.title.form'), filters['form57'])} key="filter-13">
            <div className="filter">
              <ul>
                <li>{ t('messages.aml.active') } <Switch size="small" checked={ filters['form57']?.includes('ACTIVE') } onChange={ (value) => onChangeFilters('form57', 'ACTIVE', value) } /></li>
                <li>{ t('messages.aml.inactive') } <Switch size="small" checked={ filters['form57']?.includes('INACTIVE') } onChange={ (value) => onChangeFilters('form57', 'INACTIVE', value) }/></li>
              </ul>
            </div>
          </Panel>
        }
        { currentUser.cliente.modules.includes('ADMCLI') && parametersClient && parametersClient.ubofinder && !parametersClient.ubofinder.sinFormulario &&
          <Panel header={getTitleFilter(t('messages.aml.ubofinder.status.form'), filters['estadoForm'])} key="filter-12">
            <div className="filter">
              <ul>
                <li>{ t('messages.aml.notDelivered') } <Switch size="small" checked={ filters['estadoForm'] && filters['estadoForm'].includes('N') } onChange={ (value) => onChangeFilters('estadoForm', 'N', value) } /></li>
                <li>{ t('messages.aml.delivered') } <Switch size="small" checked={ filters['estadoForm'] && filters['estadoForm'].includes('ENVIADO') } onChange={ (value) => onChangeFilters('estadoForm', 'ENVIADO', value) } /></li>
                <li>{ t('messages.aml.received') } <Switch size="small" checked={ filters['estadoForm'] && filters['estadoForm'].includes('RECIBIDO') } onChange={ (value) => onChangeFilters('estadoForm', 'RECIBIDO', value) } /></li>
                <li>{ t('messages.aml.validated') } <Switch size="small" checked={ filters['estadoForm'] && filters['estadoForm'].includes('VALIDADO') } onChange={ (value) => onChangeFilters('estadoForm', 'VALIDADO', value) } /></li>
              </ul>
            </div>
          </Panel>
        }
        { origin === 'new' && currentUser.cliente.modules.includes('MONITOR-AML') &&
          <Panel header={getTitleFilter(t('messages.aml.compliance'), getComplianceTitleOptions())} key="filter-15">
            <div className="filter">
              <ul className="compliance-filters">
                { currentUser.cliente.modules.includes('PEPSAN') &&
                  <li>
                    <div className="compliance-filter-row">
                      <Tooltip title={t('messages.aml.compliance.PEPSAN')} placement="topLeft">
                        <span className="compliance-filter-label">{ t('messages.aml.compliance.PEPSAN') }</span>
                      </Tooltip>
                      <Switch size="small" checked={ isComplianceActive('PEPSAN') } onChange={ (value) => handleComplianceChange('PEPSAN', value) } />
                    </div>
                    { renderComplianceBases('PEPSAN') }
                  </li>
                }
                { currentUser.cliente.modules.includes('KYCAME') &&
                  <li>
                    <div className="compliance-filter-row">
                      <Tooltip title={t('messages.aml.compliance.KYCAME')} placement="topLeft">
                        <span className="compliance-filter-label">{ t('messages.aml.compliance.KYCAME') }</span>
                      </Tooltip>
                      <Switch size="small" checked={ isComplianceActive('KYCAME') } onChange={ (value) => handleComplianceChange('KYCAME', value) } />
                    </div>
                    { renderComplianceBases('KYCAME') }
                  </li>
                }
                { currentUser.cliente.modules.includes('UBOCOM') &&
                  <li>
                    <div className="compliance-filter-row">
                      <Tooltip title={t('messages.aml.compliance.UBOCOM')} placement="topLeft">
                        <span className="compliance-filter-label">{ t('messages.aml.compliance.UBOCOM') }</span>
                      </Tooltip>
                      <Switch size="small" checked={ isComplianceActive('UBOCOM') } onChange={ (value) => handleComplianceChange('UBOCOM', value) } />
                    </div>
                    { renderComplianceBases('UBOCOM') }
                  </li>
                }
                { currentUser.cliente.modules.includes('ONBOARDING') &&
                  <li>
                    <div className="compliance-filter-row">
                      <Tooltip title={t('messages.aml.compliance.ONB')} placement="topLeft">
                        <span className="compliance-filter-label">{ t('messages.aml.compliance.ONB') }</span>
                      </Tooltip>
                      <Switch size="small" checked={ isComplianceActive('ONB') } onChange={ (value) => handleComplianceChange('ONB', value) } />
                    </div>
                    { renderComplianceBases('ONB') }
                  </li>
                }
              </ul>
            </div>
          </Panel>
        }
        { origin === 'new' &&
          <Panel header={ getTitleFilter(t('messages.aml.assignedRisk'), filters['asignedRisk']) } key="filter-16">
            <div className="filter">
              <ul>
                <li>{ t('messages.aml.risk.BLACK') } <Switch size="small" checked={ filters['asignedRisk'] && filters['asignedRisk'].includes('BLACK') } onChange={ (value) => onChangeFilters('asignedRisk', 'BLACK', value) } /></li>
                <li>{ t('messages.aml.risk.RED') } <Switch size="small" checked={ filters['asignedRisk'] && filters['asignedRisk'].includes('RED') } onChange={ (value) => onChangeFilters('asignedRisk', 'RED', value) } /></li>
                <li>{ t('messages.aml.risk.ORANGE') } <Switch size="small" checked={ filters['asignedRisk'] && filters['asignedRisk'].includes('ORANGE') } onChange={ (value) => onChangeFilters('asignedRisk', 'ORANGE', value) } /></li>
                <li>{ t('messages.aml.risk.YELLOW') } <Switch size="small" checked={ filters['asignedRisk'] && filters['asignedRisk'].includes('YELLOW') } onChange={ (value) => onChangeFilters('asignedRisk', 'YELLOW', value) } /></li>
                <li>{ t('messages.aml.risk.GREEN') } <Switch size="small" checked={ filters['asignedRisk'] && filters['asignedRisk'].includes('GREEN') } onChange={ (value) => onChangeFilters('asignedRisk', 'GREEN', value) } /></li>
              </ul>
            </div>
          </Panel>
        }
        { origin === 'new' &&
          <Panel header={getTitleFilter(t('messages.aml.comments'), filters['hasComments'])} key="filter-14">
            <div className="filter">
              <ul>
                <li>{ t('messages.aml.advancedFilters.hasComments') } <Switch size="small" checked={ filters['hasComments']?.includes('ON') } onChange={ (value) => onChangeFilters('hasComments', 'ON', value) } /></li>
                <li>{ t('messages.aml.advancedFilters.noComments') } <Switch size="small" checked={ filters['hasComments']?.includes('OFF') } onChange={ (value) => onChangeFilters('hasComments', 'OFF', value) }/></li>
              </ul>
            </div>
          </Panel>
        }
        { origin === 'new' && currentUser.cliente.modules.includes('MONITOR-AML') &&
          <Panel header={t('messages.aml.riskDateAml')} key="filter-17">
            <div className="filter">
              <DatePicker format="DD/MM/YYYY" placeholder={ t('messages.aml.from') } style={{ marginBottom: '5px', width: '100%' }} onChange={ (value) => onChangeFilters('fromDateRisk', value === null ? null : moment(value).format('DD/MM/YYYY'), value !== '') } />
              <DatePicker format="DD/MM/YYYY" placeholder={ t('messages.aml.to') } style={{ width: '100%' }} onChange={ (value) => onChangeFilters('toDateRisk', value === null ? null : moment(value).format('DD/MM/YYYY'), value !== '') } />
            </div>
          </Panel>
        }
                {/*<div className="filter">
                    <h5>{ t('messages.aml.term') }</h5>
                    <ul>
                      <li>{ t('messages.aml.green') } <Switch size="small" checked={ filters['estadoPlazo'] !== null && filters['estadoPlazo'] !== undefined && filters['estadoPlazo'].includes('GREEN') } onChange={ (value) => onChangeFilters('estadoPlazo', 'GREEN', value) } /></li>
                      <li>{ t('messages.aml.yellow') } <Switch size="small" checked={ filters['estadoPlazo'] !== null && filters['estadoPlazo'] !== undefined && filters['estadoPlazo'].includes('YELLOW') } onChange={ (value) => onChangeFilters('estadoPlazo', 'YELLOW', value) } /></li>
                      <li>{ t('messages.aml.red') } <Switch size="small" checked={ filters['estadoPlazo'] !== null && filters['estadoPlazo'] !== undefined && filters['estadoPlazo'].includes('RED') } onChange={ (value) => onChangeFilters('estadoPlazo', 'RED', value) } /></li>
                    </ul>
                  </div>
                  <div className="filter">
                    <h5>{ t('messages.aml.verification') }</h5>
                    <ul>
                      <li>{ t('messages.aml.green') } <Switch size="small" checked={ filters['estadoVerif'] !== null && filters['estadoVerif'] !== undefined && filters['estadoVerif'].includes('GREEN') } onChange={ (value) => onChangeFilters('estadoVerif', 'GREEN', value) } /></li>
                      <li>{ t('messages.aml.yellow') } <Switch size="small" checked={ filters['estadoVerif'] !== null && filters['estadoVerif'] !== undefined && filters['estadoVerif'].includes('YELLOW') } onChange={ (value) => onChangeFilters('estadoVerif', 'YELLOW', value) } /></li>
                      <li>{ t('messages.aml.red') } <Switch size="small" checked={ filters['estadoVerif'] !== null && filters['estadoVerif'] !== undefined && filters['estadoVerif'].includes('RED') } onChange={ (value) => onChangeFilters('estadoVerif', 'RED', value) } /></li>
                    </ul>
                  </div>*/}
      </Collapse>
    </div>
  )
}

export default Filters
